"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentFlaggingStatus = void 0;
var ContentFlaggingStatus;
(function (ContentFlaggingStatus) {
    ContentFlaggingStatus["Pending"] = "Pending";
    ContentFlaggingStatus["Assigned"] = "Assigned";
    ContentFlaggingStatus["Removed"] = "Removed";
    ContentFlaggingStatus["Retained"] = "Retained";
})(ContentFlaggingStatus || (exports.ContentFlaggingStatus = ContentFlaggingStatus = {}));
